import { dsLogger } from '../../shared/services/logger/logger.instance';

export const filterModalLogger = dsLogger.extend('filter-modal');
